export default __webpack_public_path__ + "static/topic21-2383e869863e9ae1eaee2c5eb7382415.png";